import { useEffect, useMemo, useState } from 'react';
import { useMutation } from 'react-query';
import { Users } from '~/api/scheme';
import useCurrentUser from '../useCurrentUser';

export type DenseProps = {
  dense: boolean;
  onChangeDense: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

type Args = {
  scope: UISettingsScope;
  savedDense: boolean;
  showMaskSettings: boolean;
};

const DEFAULT_DENSE = true;

const useDense = (args: Args): DenseProps => {
  const { savedDense, showMaskSettings, scope } = args;
  // TODO: move to common hooks
  const { currentUser } = useCurrentUser();

  const mutation = useMutation((params: Users.UISettings.UpdateColumnsParams) =>
    Users.UISettings.update(params)
  );

  const [denseState, setDense] = useState<boolean | null>(null);

  const dense = useMemo(
    () => denseState ?? (savedDense || DEFAULT_DENSE),
    [denseState, savedDense]
  );

  // ! To initiate re-render
  useEffect(() => {
    setDense(null);
  }, [showMaskSettings]);

  const onChangeDense = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.checked;

    setDense(newValue);

    mutation.mutate({
      user_id: Number(currentUser?.id),
      update_mask: showMaskSettings,
      ui_settings: { [scope]: { dense: newValue } },
    });
  };

  return {
    dense,
    onChangeDense,
  };
};

export default useDense;
